//用户状态配置
let passengerStatus={
  //启用
  NORMAL:2,
  //禁用
  PROHIBIT:4
}

export default {
  passengerStatus
};




// WEBPACK FOOTER //
// ./src/static/js/lib/config.js